import { RoutingStatusCodes } from '../consts';

export const calculateGroupStatus = (
  ...statuses: RoutingStatusCodes[]
): RoutingStatusCodes => {
  if (statuses.some((s) => s === RoutingStatusCodes.Processing))
    return RoutingStatusCodes.Processing;
  if (statuses.every((s) => s === RoutingStatusCodes.Done))
    return RoutingStatusCodes.Done;
  return RoutingStatusCodes.Error;
};
